<template>
  <div class="modal-container window">
    <detail-header
        :pcdType="-1"
        :formDataObj="formData"
        :isSubmit="isSubmit"
        :isEdit="true"
        @payObj="getPayObj"
        :isLoaded="isLoaded"
        :isHasDo="true"
        :isOrder="isOrder"
        @selectComp="selectCompName"
    ></detail-header>
    <div class="add-box clearfix pay-modal-main">
      <table-header @add="insertEvent" @remove="removeEvent" @copy="copyEvent"></table-header>
      <vxe-table
          border
          show-overflow
          keep-source
          class="table-style produre"
          ref="xTable"
          highlight-hover-row
          max-height="680"
          :data="tableData"
          :edit-rules="editRules"
          :auto-resize="true"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          @cell-click="cellClickEvent"
          @scroll="$refs.xTable.clearValidate()"
          :show-footer="true"
          :footer-method="footerMethod"
          :footer-cell-class-name="footerCellClassName"
          v-show="cate === 'Sales'"
          resizable
      >
        <vxe-table-column width="50" align="center" type="checkbox"></vxe-table-column>
        <vxe-table-column width="60" align="center" field="index" title="序号" v-if="isImport"></vxe-table-column>
        <vxe-table-column type="seq" width="60" align="center" title="序号" v-else></vxe-table-column>
        <vxe-table-column field="ordersNum" width="150" title="关联订单" align="center">
          <template v-slot="{ row }">
            <div style="display: flex;align-items: center;justify-content: center;">
              <div v-if="isinitByOrder">
                <em>{{ row.ordersNum }}</em>
              </div>
              <div :class="{ 'link-text': canInsert }" v-else>
                {{ row.ordersNum == null || row.ordersNum == "" ? "选择关联订单" : row.ordersNum }}
              </div>
              <img v-if="row.ordersNum"
                   style="height: 10px;width: 10px;cursor: pointer;"
                   src="~assets/images/common/close.png"
                   @click.stop="removeOrder(row)"/>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="invoiceNum" width="130" title="发票号码">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.invoiceNum"
                placeholder="输入发票号码"
                maxlength="25"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="addTime" title="开票日期">
          <!--          <template v-slot:header="{ column }">-->
          <!--            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
          <!--          </template>-->
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.addTime"
                placeholder="选择日期"
                type="date"
                transfer
                clearable
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="150" field="invoiceType" title="发票类型">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.invoiceType"
                placeholder="请选择"
                :options="invoiceType"
                transfer
                @change="changeInvoiceType(row)"
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column width="200" field="invoiceTitle" title="发票抬头">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="scope">
            <div class="link-text" @click="openChooseAccount(scope.row, 'invoiceTitle')">
              {{ scope.row.invoiceTitle ? scope.row.invoiceTitle : "请选择账户" }}
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column width="150" field="goodsName" title="货名">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.goodsName" placeholder="必填" maxlength="25"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="50" field="unit" title="单位">
          <template v-slot="{ row }">
            <vxe-input v-model="row.unit" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="counts" title="数量">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.counts"
                placeholder="选填"
                type="number"
                v-on:input="calcMoney(scope.row, 'counts')"
                @input="$refs.xTable.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="price" title="不含税单价(元)">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.price"
                placeholder="选填"
                type="number"
                min="0"
                v-on:input="calcMoney(scope.row, 'price')"
                @input="$refs.xTable.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="totalAmount" title="不含税金额">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.totalAmount"
                placeholder="选填"
                type="number"
                :digits="2"
                v-on:input="calcMoneyAll(scope.row, 'totalAmount')"
                @input="$refs.xTable.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="80" field="taxRate" title="税率(%)">
          <!--          <template v-slot:header="{ column }">-->
          <!--            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
          <!--          </template>-->
          <template v-slot="scope">
            <vxe-select v-model="scope.row.taxRate" transfer>
              <vxe-option
                  v-for="(item, index) in tax_rate"
                  :key="index"
                  :value="item.label"
                  :label="item.label"
                  @change="change(scope.row)"
              ></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column width="100" field="taxAmount" title="税额(元)">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.taxAmount"
                placeholder="选填"
                type="number"
                v-on:input="calcMoneySecAll(scope.row, 'taxAmount')"
                @input="$refs.xTable.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="taxTotalAmount" title="价税合计(元)">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.taxTotalAmount"
                placeholder="必填"
                type="number"
                :digits="2"
                v-on:input="calcMoneyTreAll(scope.row, 'taxTotalAmount')"
                @input="$refs.xTable.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="salesMan" width="100" title="业务员" align="center">
          <template v-slot="scope">
            <div>
              <sales-man
                  :row="scope.row"
                  :field="'salesMan'"
                  :rowIndex="scope.$rowIndex"
                  @setSaleMan="getSaleManInfo"
                  :clearable="false"
              ></sales-man>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="rateManage" width="130" title="费率(%)" align="center">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.rateManage"
                placeholder=""
                type="number"
                v-on:input="calcMoneyTreAll(scope.row, 'rateManage')"
                @input="$refs.xTable.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="manageAmount" width="130" title="服务费" align="center">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.manageAmount"
                v-on:input="updateFooterEvent()"
                placeholder="自动计算"
                maxlength="25"
                type="number"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="150" field="carShipNum" title="车船名">
          <template v-slot="{ row }">
            <div class="link-text" @click="showChooseCarShip(row)">
              {{ row.carShipNum == null || row.carShipNum == "" ? "选填" : row.carShipNum }}
              <img v-if="row.carShipNum"
                   style="height: 10px;width: 10px;cursor: pointer;"
                   src="~assets/images/common/close.png"
                   @click.stop="removeCarShip(row)"/>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column width="100" field="beginPlace" title="起运地">
          <template v-slot="{ row }">
            <vxe-input v-model="row.beginPlace" placeholder="选填" maxlength="25"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="100" field="endPlace" title="到达地">
          <template v-slot="{ row }">
            <vxe-input v-model="row.endPlace" placeholder="选填" maxlength="25"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="140" field="laydays" title="起运日期">
          <template v-slot="{ row }">
            <vxe-input v-model="row.laydays" placeholder="选填" type="date" transfer :editable="false"
                       clearable></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="100" field="note" title="备注">
          <template v-slot="{ row }">
            <vxe-input v-model="row.note" placeholder="选填" maxlength="200"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="100" field="logisticsComp" title="快递公司">
          <template v-slot="{ row }">
            <vxe-input v-model="row.logisticsComp" placeholder="选填" maxlength="20"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="200" field="logisticsNum" title="物流单号">
          <template v-slot="{ row }">
            <vxe-input v-model="row.logisticsNum" placeholder="选填" maxlength="30"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="150" field="fileList" title="操作" align="center">
          <template v-slot="{ row }">
            <upload-row :row="row" :initFileList="row.fileList"></upload-row>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-table
          border
          show-overflow
          keep-source
          class="table-style produre"
          ref="xTable1"
          highlight-hover-row
          max-height="680"
          :data="tableData"
          :edit-rules="editRules1"
          :auto-resize="true"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          @cell-click="cellClickEvent"
          @scroll="$refs.xTable1.clearValidate()"
          :show-footer="true"
          :footer-method="footerMethod"
          :footer-cell-class-name="footerCellClassName"
          v-show="cate === 'Income'"
          resizable
      >
        <vxe-table-column width="50" align="center" type="checkbox"></vxe-table-column>
        <vxe-table-column width="60" align="center" field="index" title="序号" v-if="isImport"></vxe-table-column>
        <vxe-table-column type="seq" width="60" align="center" title="序号" v-else></vxe-table-column>
        <vxe-table-column field="ordersNum" width="150" title="关联订单" align="center">
          <template v-slot="{ row }">
            <div style="display: flex;align-items: center;justify-content: center;">
              <div v-if="isinitByOrder">
                <em>{{ row.ordersNum }}</em>
              </div>
              <div :class="{ 'link-text': canInsert }" v-else>
                {{ row.ordersNum == null || row.ordersNum == "" ? "选择关联订单" : row.ordersNum }}
              </div>
              <img v-if="row.ordersNum"
                   style="height: 10px;width: 10px;cursor: pointer;"
                   src="~assets/images/common/close.png"
                   @click.stop="removeOrder(row)"/>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="invoiceNum" width="130" title="发票号码">
          <!--          <template v-slot:header="{ column }">-->
          <!--            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
          <!--          </template>-->
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.invoiceNum"
                placeholder="输入发票号码"
                maxlength="25"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="addTime" title="开票日期">
          <!--          <template v-slot:header="{ column }">-->
          <!--            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
          <!--          </template>-->
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.addTime"
                placeholder="选择日期"
                type="date"
                transfer
                clearable
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="deductTime" title="抵扣日期">
          <!--          <template v-slot:header="{ column }">-->
          <!--            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
          <!--          </template>-->
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.deductTime"
                placeholder="选择日期"
                type="date"
                transfer
                clearable
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="150" field="invoiceType" title="发票类型">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.invoiceType"
                placeholder="请选择"
                :options="invoiceType"
                transfer
                @change="changeInvoiceType(row)"
            ></vxe-select>
          </template>
        </vxe-table-column>

        <!-- 销项发票--托运人订单 -->
        <!-- 进项发票--承运人订单 -->
        <vxe-table-column width="200" field="invoiceCompName" title="开票单位">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="scope">
            <div @click="openChooseAccount(scope.row, 'invoiceCompName')" class="link-text">
              <span v-if="scope.row.invoiceCompName">{{ scope.row.invoiceCompName }}</span>
              <span v-else>请选择账户</span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column width="150" field="goodsName" title="货名">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.goodsName" placeholder="必填" maxlength="25"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="50" field="unit" title="单位">
          <template v-slot="{ row }">
            <vxe-input v-model="row.unit" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="counts" title="数量">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.counts"
                placeholder="选填"
                type="number"
                v-on:input="calcMoney(scope.row, 'counts')"
                @input="$refs.xTable1.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="price" title="不含税单价(元)">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.price"
                placeholder="选填"
                type="number"
                min="0"
                v-on:input="calcMoney(scope.row, 'price')"
                @input="$refs.xTable1.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="totalAmount" title="不含税金额">
          <!--          <template v-slot:header="{ column }">-->
          <!--            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
          <!--          </template>-->
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.totalAmount"
                placeholder="必填"
                type="number"
                v-on:input="calcMoneyAll(scope.row, 'totalAmount')"
                @input="$refs.xTable1.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="80" field="taxRate" title="税率(%)">
          <!--          <template v-slot:header="{ column }">-->
          <!--            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
          <!--          </template>-->
          <template v-slot="scope">
            <vxe-select v-model="scope.row.taxRate" transfer>
              <vxe-option
                  v-for="(item, index) in tax_rate"
                  :key="index"
                  :value="item.label"
                  :label="item.label"
                  @change="change(scope.row)"
              ></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column width="100" field="taxAmount" title="税额(元)">
          <!--          <template v-slot:header="{ column }">-->
          <!--            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>-->
          <!--          </template>-->
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.taxAmount"
                placeholder="必填"
                type="number"
                v-on:input="calcMoneySecAll(scope.row, 'taxAmount')"
                @input="$refs.xTable1.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="taxTotalAmount" title="价税合计(元)">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.taxTotalAmount"
                placeholder="必填"
                type="number"
                v-on:input="calcMoneyTreAll(scope.row, 'taxTotalAmount')"
                @input="$refs.xTable1.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="salesMan" width="100" title="抵扣业务员" align="center">
          <template v-slot="scope">
            <div>
              <sales-man
                  :row="scope.row"
                  :field="'salesMan'"
                  :rowIndex="scope.$rowIndex"
                  @setSaleMan="getSaleManInfo"
                  :isEdit="!scope.row.isSub"
                  :clearable="false"
              ></sales-man>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column width="150" field="deductType" title="抵扣方式">
          <template v-slot="scope">
            <vxe-select
                v-model="scope.row.deductType"
                placeholder="请选择"
                :options="deductType"
                transfer
                @change="changeDeductType(scope.$rowIndex)"
                clearable
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="rateDeduct" width="130" title="抵扣比例(%)" align="center">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.rateDeduct"
                placeholder=""
                type="number"
                v-on:input="calcMoneyTreAll(scope.row, 'rateDeduct')"
                @input="$refs.xTable1.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="manageAmount" width="130" title="抵扣服务费" align="center">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.manageAmount"
                v-on:input="updateFooterEvent()"
                placeholder="自动计算"
                maxlength="25"
                type="number"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="100" field="carShipNum" title="车船名">
          <template v-slot="{ row }">
            <div class="link-text" @click="showChooseCarShip(row)">
              {{ row.carShipNum == null || row.carShipNum == "" ? "选填" : row.carShipNum }}
              <img v-if="row.carShipNum"
                   style="height: 10px;width: 10px;cursor: pointer;"
                   src="~assets/images/common/close.png"
                   @click.stop="removeCarShip(row)"/>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column width="100" field="beginPlace" title="起运地">
          <template v-slot="{ row }">
            <vxe-input v-model="row.beginPlace" placeholder="选填" maxlength="25"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="100" field="endPlace" title="到达地">
          <template v-slot="{ row }">
            <vxe-input v-model="row.endPlace" placeholder="选填" maxlength="25"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="140" field="laydays" title="起运日期">
          <template v-slot="{ row }">
            <vxe-input v-model="row.laydays" placeholder="选填" type="date" transfer :editable="false"
                       clearable></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="100" field="note" title="备注">
          <template v-slot="{ row }">
            <vxe-input v-model="row.note" placeholder="选填" maxlength="200"></vxe-input>
          </template>
        </vxe-table-column>

        <vxe-table-column width="150" field="replaceTaxpayer" title="纳税人名称">
          <template v-slot="{ row }">
            <div class="link-text" @click="openChoosePerson(row, 'replaceTaxpayer')">
              {{ row.replaceTaxpayer ? row.replaceTaxpayer : "请选择" }}
              <img v-if="row.replaceTaxpayer"
                   style="height: 10px;width: 10px;cursor: pointer;"
                   src="~assets/images/common/close.png"
                   @click.stop="removeReplaceTaxpayer(row)"/>
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column width="170" field="repalceTaxNum" title="纳税人证件号码">
          <template v-slot="{ row }">
            <vxe-input v-model="row.repalceTaxNum" placeholder="选填" disabled maxlength="18"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="150" field="fileList" title="操作" align="center">
          <template v-slot="{ row }">
            <upload-row :row="row" :initFileList="row.fileList"></upload-row>
          </template>
        </vxe-table-column>
      </vxe-table>
      <upload-table ref="uploadTable" style="margin-top: 20px;margin-bottom: 50px;" :row="uploadData[0]"
                    :initFileList="fileList"></upload-table>
      <div class="footer-btn">
        <Button type="primary" @click="impotEvent" v-if="isImport || isCurImport">上传导入文件
        </Button>
        <Button type="primary" @click="submitEvent('new')">提 交</Button>
        <Button type="primary" class="left10" @click="showTempModal" v-if="authCreate() && !isCurImport && !isImport">
          批量导入
        </Button>
        <Button type="primary" class="left10" @click="submitEvent('save')">保存</Button>
      </div>
    </div>

    <!-- 弹窗 -->
    <!-- 选择关联订单 -->
    <vxe-modal v-model="isShowChooseOrder" width="1475" height="650" resize remember :title="'选择关联订单'" destroy-on-close>
      <choose-match-order @chooseOrder="chooseOrderEvent" ref="chooseOrder"
                          v-if="cate === 'Sales'"></choose-match-order>
      <choose-order-two @chooseOrder="chooseOrderEvent" ref="chooseOrder" v-else :isSub="true"></choose-order-two>
    </vxe-modal>
    <!-- 选择企业 -->
    <vxe-modal v-model="isShowChooseAccount" width="800" height="600" resize remember
               :title="currentChooseColumn == 'invoiceTitle' ? '发票抬头' : '开票单位'">
      <choose-account @choose="chooseAccountEvent" ref="chooseAccount" :notPer="true"></choose-account>
    </vxe-modal>
    <vxe-modal v-model="isShowInvoiceAccount" width="800" height="600" resize remember
               title="选择客户">
      <invoice-account @choose="chooseInvoiceAccountEvent" ref="chooseInvoiceAccount"></invoice-account>
    </vxe-modal>
    <!-- 选择车船 -->
    <vxe-modal v-model="isShowChooseCarShip" width="1200" height="600" resize remember :title="'选择车船'">
      <choose-car-ship ref="chooseCarShip" @choose="chooseCarShip"></choose-car-ship>
    </vxe-modal>
    <vxe-modal v-model="templateVisible" title="发票信息导入" width="1000" height="650" @close="closeTemplate" remember>
      <import @goImport="goImport" @close="closeTemplate" ref="modalTemplate"></import>
    </vxe-modal>
    <vxe-modal
        v-model="messageVisible"
        title="消息提示"
        width="600"
        height="350"
        @close="closeMessage"
        position="center"
    >
      <Message ref="messageModal" @close="closeMessage" @cover="cover" :btnText="'继续提交'" :conImport="true"
               :isCommit="true"></Message>
    </vxe-modal>
    <vxe-modal
        v-model="messageVisible2"
        title="消息提示"
        width="600"
        height="350"
        @close="messageVisible2 = false"
        position="center"
    >
      <Message ref="messageModal2" @close="messageVisible2 = false" @cover="goOn" :btnText="'继续提交'" :conImport="true"
               :isCommit="true"></Message>
    </vxe-modal>
  </div>
</template>

<script>
import $C from "@/consts/index";
import $api from "@/apiProvider";
import XLSX from "xlsx";
import ChooseOrderTwo from "@/components/proceduremodal/ChooseInvoiceOrder";
import ChooseMatchOrder from "@/components/proceduremodal/ChooseMatchInvoice";
import UploadList from "@/components/common/UploadList";
import Account from "@/components/modal/Account";
import InvoiceAccount from "@/components/modal/InvoiceAccount";
import PlatformCorp from "@/components/common/PlatformCorp";
import ChooseCarShip from "@/components/modal/ChooseCarShip";
import TableHeader from "@/components/common/TableHeader";
import SalesMan from "@/components/common/SalesMan";
import DetailHeader from "@/views/procedure/DetailHeader";
import Import from "@/components/common/Import"; //
import auth from "@/utils/auth";
import {
  getExcelTime,
  hideLoading,
  invoiceFooter,
  isEmpty,
  isNotEmpty,
  showFailMsgList,
  showLoading,
} from "@/utils/util";
import {timeFormatDate} from "@/filters/time";
import getAuthOrization from "@/mixin/getAuthOrization";
import {requireValidTaxpayer} from "@/utils/valid";
import UploadRow from "@/components/modal/UploadRow";
import UploadTable from "@/components/modal/UploadTable";
import Message from "@/components/common/Message";

const assign = (o) => Object.assign({}, o);
const empties = [undefined, "", null, "null", {}, []];

export default {
  mixins: [getAuthOrization],
  name: "CreateInvoice",
  components: {
    SalesMan,
    TableHeader,
    ChooseOrderTwo,
    ChooseAccount: Account,
    ChooseCarShip,
    DetailHeader,
    Import,
    ChooseMatchOrder,
    UploadRow,
    InvoiceAccount,
    UploadTable,
    Message
  },
  props: {
    // cate: {
    //   type: String, // Sales, Income
    //   default: "",
    // },
    // isShow: {
    //   type: Boolean,
    //   default: false,
    // },
    isImport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let userInfoValue = {};
    if (auth.isLogin()) {
      userInfoValue = auth.getAuth();
    }
    return {
      userInfoValue,
      messageVisible2: false,
      messageVisible: false,
      isShowInvoiceAccount: false,
      isOrder: false,
      isSalesMan: false,
      canInsert: true,
      orderInsert: true,
      canEdit: true,
      dicByParentData: [], //配置信息
      isShowChooseOrder: false,
      isShowChooseAccount: false,
      isShowChooseCarShip: false,
      invoiceType: $C.invoiceType.options,
      deductType: $C.deductType.options,
      currentChooseColumn: "",
      dataTmp: {
        index: 1,
        addTime: null,
        deductTime: null, // 抵扣日期 进项发票
        amount: null,
        beginPlace: null,
        carShipNum: null,
        compName: null,
        endPlace: null,
        fileUuidList: [],
        fileList: [],
        goodsName: null,
        counts: null,
        price: null,
        canEdit: true,
        unit: null,
        taxAmount: null,
        taxRate: 9,
        invoiceNum: null,
        invoiceCompName: null,
        invoiceTitle: null,
        invoiceType: 2,
        laydays: null,
        replaceTaxpayer: null,
        repalceTaxNum: null,
        linkMan: null,
        logisticsComp: null,
        logisticsNum: null,
        note: null,
        ordersBuyerId: null,
        ordersSellerId: null,
        ordersNum: null,
        salesMan: null,
        rateManage: null,
        manageAmount: null,
        totalAmount: null,
        deductType: null, // 抵扣方式 进项发票
        rateDeduct: null,
        orderRateDeduct: null,
        orderRateDeductManage: null,
        taxTotalAmount: null
      },
      tableData: [],
      orderListType: false,
      editRules: {
        repalceTaxNum: [{validator: this.requireValidTwo,},],
        replaceTaxpayer: [{validator: this.requireValidTwo,},],
        // addTime: [{validator: this.requireValid,},],
        deductTime: [{validator: this.requireValid,},],
        invoiceType: [{validator: this.requireValid,},],
        invoiceCompName: [{validator: this.requireValid,},],
        invoiceTitle: [{validator: this.requireValid,},],
        goodsName: [{validator: this.requireValid,},],
        taxRate: [{validator: this.requireValid,},],
        amount: [{validator: this.requireValid,},],
        taxTotalAmount: [{validator: this.requireValid,},],
      },
      editRules1: {
        repalceTaxNum: [{validator: this.requireValidTwo,},],
        replaceTaxpayer: [{validator: this.requireValidTwo,},],
        // invoiceNum: [{validator: this.requireValid,},],
        // addTime: [{validator: this.requireValid,},],
        // deductTime: [{validator: this.requireValid,},],
        invoiceType: [{validator: this.requireValid,},],
        invoiceCompName: [{validator: this.requireValid,},],
        invoiceTitle: [{validator: this.requireValid,},],
        goodsName: [{validator: this.requireValid,},],
        // taxRate: [{validator: this.requireValid,},],
        // amount: [{validator: this.requireValid,},],
        taxTotalAmount: [{validator: this.requireValid,},],
        // totalAmount: [{validator: this.requireValid,},],
        // taxAmount: [{validator: this.requireValid,},],
      },
      formData: {},
      isSubmit: false,
      flowTempletId: 3,
      isLoaded: false,
      chainId: null,
      templateVisible: false,
      isCurImport: false,
      isinitByOrder: false,
      tax_rate: [],
      isInitBySave: false,
      initBySaveId: null,
      matchOrder: false,
      cate: '',
      isShow: false,
      uploadData: [
        {
          fileList: null,
        },
      ],
      fileList: [],
    };
  },
  watch: {
    isShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val == false && oldVal == true) {
          this.$refs[this.tableName].clearValidate();
          this.tableData = [];
          this.canInsert = true;
          this.orderInsert = true;
          this.isSubmit = false;
          this.isLoaded = false;
          this.isCurImport = false;
          this.isinitByOrder = false;
        }
        if (val == true && !this.isInitBySave) {
          // this.tableData = [assign(this.dataTmp)];
          this.insertEvent();
          let id = this.cate === "Income" ? 9 : 8;
          this.getFlowData(id);
        }
      },
    },
  },
  computed: {
    tableName() {
      return this.cate === 'Sales' ? "xTable" : "xTable1";
    },
  },
  // beforeMount() {
  //   let id = this.cate === "Income" ? 4 : 3
  //   console.log(id, '111111');
  //   debugger
  //   this.getFlowData(id)
  //   // this.getDicByParentList()
  // },
  created() {
    this.isShow = true;
    this.getDictByCode(603, "tax_rate");
  },
  mounted() {
    this.cate = this.$route.params.cate;
    document.title = this.cate === 'Sales' ? '开票申请流程' : '抵扣票申请流程'
    if (this.$route.params.flowId) {
      this.initBySave(this.$route.params.flowId);
    }
    if (this.$route.params.isOrder) {
      this.isOrder = true;
      let detailData = JSON.parse(localStorage.getItem('detailData'))
      this.initByOrderInfo(detailData);
    }
  },
  methods: {
    removeOrder(row) {
      this.$set(row, 'ordersNum', null);
      this.$set(row, 'ordersId', null);
    },
    removeCarShip(row) {
      this.$set(row, 'carShipNum', null);
    },
    removeReplaceTaxpayer(row) {
      this.$set(row, 'replaceTaxpayer', null);
    },
    closeMessage() {
      this.messageVisible = false;
    },
    change(row) {
      this.calcMoneyAll(row);
      this.$refs[this.tableName].clearValidate();
    },
    async getDictByCode(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    initByChainId(chainId) {
      this.chainId = chainId;
      this.isinitByOrder = true;
      // let orderInfo = this.getBuyerOrderInfoByChainId(chainId);
      // orderInfo.then(res => {
      //   if (null != res) {
      //     this.initByOrderInfo(res);
      //   }
      // })
    },
    async initBySave(id) {
      this.isInitBySave = true;
      this.initBySaveId = id;
      $api.flowInstance.queryDraftFlowDetail
          .GET({
            params: {
              id,
            },
          })
          .then((res) => {
            if (res.status === 1) {
              this.flowTempletId = res.data.templetType;
              document.title = res.data.instanceName;
              this.formData = Object.assign(res.data, {
                payType: res.data.payType === 0 ? 1 : 0,
              });
              this.isLoaded = true;
              this.fileList = res.data.attachFile;
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          });
      let params = {
        page: 1,
        rows: 10000,
        orderBy: 2,
        isDesc: 0,
        flowId: id,
      };
      // 开票
      if (this.cate === "Sales") {
        let resData = await $api.invoiceTwo.request("queryInvoiceSellerListSelect", params);
        if (resData.status == 1) {
          this.tableData = resData.data.rows.map((item) => {
            return Object.assign(item, {
              addTime: item.addTime ? timeFormatDate(item.addTime) : null,
              laydays: item.laydays ? timeFormatDate(item.laydays) : null,
              canEdit: true,
            });
          });
          if (this.tableData[0]) {
            this.formData.compName = this.tableData[0].compName;
          }
        }
      } else {
        let resData = await $api.invoiceTwo.request("queryInvoiceBuyerListSelect", params);
        if (resData.status == 1) {
          this.tableData = resData.data.rows.map((item) => {
            return Object.assign(item, {
              addTime: timeFormatDate(item.addTime),
              deductTime: timeFormatDate(item.deductTime),
              laydays: timeFormatDate(item.laydays),
              canEdit: true,
            });
          });
          if (this.tableData[0]) {
            this.formData.compName = this.tableData[0].compName;
          }
        }
      }
    },
    getPayObj(val) {
      this.formData = val;
      // this.payType = val.type;
    },
    getFlowData(id) {
      let obj = {
        flowTempletId: id,
      };
      this.flowTempletId = id;
      $api.flowInstance.createFlowModel
          .GET({
            params: obj,
          })
          .then((res) => {
            if (res.status === 1) {
              this.formData = res.data;
              document.title = res.data.instanceName;
              if (this.isOrder) {
                this.$set(this.formData, 'compName', this.orderInfo.compName);
              }
              this.isLoaded = true;
            } else {
              this.$XModal.confirm(res.message).then(() => {
                window.close();
              });
            }
          });
    },
    getSaleManInfo(val) {
      let index = val.rowIndex;
      this.currentRow = this.$refs[this.tableName].getTableData().tableData[index];
      this.currentRow.orderRateDeduct = null;
      this.currentRow.orderRateDeductManage = null;
      this.currentRow.rateManage = null;
      this.currentRow.rateDeduct = null;
      // this.currentRow.deductType = null;
      if (this.cate == "Sales") {
        if (this.currentRow.invoiceCompName && val.rateList && val.rateList.length > 0) {
          let obj = val.rateList.filter((item) => item.compName == this.currentRow.invoiceCompName);
          if (obj && obj.length > 0 && obj[0].rateManage) {
            this.currentRow.rateManage = obj[0].rateManage;
          }
          // debugger
          this.calcMoneyTreAll(this.currentRow, "rateManage");
        } else {
          this.currentRow.rateManage = null;
          this.currentRow.manageAmount = null;
        }
      } else {
        if (this.currentRow.invoiceTitle && val.rateList && val.rateList.length > 0) {
          let obj = val.rateList.filter((item) => item.compName == this.currentRow.invoiceTitle);
          if (obj && obj.length > 0 && obj[0].rateManage) {
            this.currentRow.orderRateDeduct = obj[0].rateDeduct;
            this.currentRow.orderRateDeductManage = obj[0].rateDeductManage;
            if (this.currentRow.deductType) {
              this.currentRow.rateDeduct = this.currentRow.deductType === 1 ? this.currentRow.orderRateDeduct : this.currentRow.orderRateDeductManage;
              this.calcMoneyTreAll(this.currentRow, "rateDeduct");
            } else {
              this.currentRow.rateDeduct = null;
              this.currentRow.manageAmount = null;
            }
          } else {
            this.currentRow.rateDeduct = null;
            this.currentRow.manageAmount = null;
          }
        } else {
          this.currentRow.rateDeduct = null;
          this.currentRow.manageAmount = null;
        }
      }
    },
    async querySalesDetail(rowIndex) {
      // 查询详情  获取  销售经理 和 客户代表
      let res = await $api.baseUserSales.request("querySalesDetail", {
        id: this.currentRow.salesManId,
      });
      if (res.status === 1) {
        res.data.rowIndex = rowIndex;
        this.getSaleManInfo(res.data);
      }
    },
    selectCompName(row, id, name) {
      let tableData = this.$refs[this.tableName].getTableData().fullData;
      tableData.map(i => {
        if (this.cate == 'Sales') {
          i.invoiceCompName = name;
        } else {
          i.invoiceTitle = name;
        }
        this.getInvoiceTitle(i);
      });
    },
    async getInvoiceTitle(row) {
      this.currentRow = row;
      if (this.currentRow) {
        // this.currentRow.rateDeduct = null;
        // this.currentRow.deductType = null;
        // this.currentRow.manageAmount = null;
        // if (this.userInfoValue.identityType !== 0) {
        //   //  登录不是业务员
        //   this.currentRow.salesMan = null;
        //   this.currentRow.rateManage = null;
        // } else {
        if (this.userInfoValue.identityType === 0) {
          // 登录是业务员
          let res = await $api.baseUserSales.request("querySalesDetail", {
            id: this.userInfoValue.id,
          });
          if (res.status === 1) {
            if (res.data && res.data.rateList) {
              let list = res.data.rateList;
              let rowName =
                  this.cate === "Sales"
                      ? this.currentRow.invoiceCompName
                      : this.currentRow.invoiceTitle;
              let obj = list.filter((item) => item.compName === rowName);
              if (obj && obj.length > 0 && obj[0].rateManage) {
                this.currentRow.rateManage = obj[0].rateManage;
                this.currentRow.orderRateDeduct = obj[0].rateDeduct;
                this.currentRow.orderRateDeductManage = obj[0].rateDeductManage;
                this.cate === "Sales" ? this.calcMoneyTreAll(this.currentRow, "rateManage") : "";
              } else {
                this.currentRow.rateManage = null;
                this.currentRow.orderRateDeduct = null;
                this.currentRow.orderRateDeductManage = null;
              }
            }
          } else {
            this.currentRow.rateManage = null;
          }
        }
      }
    },
    initByOrderInfo(orderInfo, matchOrder = false) {
      this.orderInfo = orderInfo;
      this.orderListType = true;
      this.matchOrder = matchOrder;
      this.$set(this.formData, 'compName', this.orderInfo.compName);
      console.log("创建发票 通过 订单号初始化", orderInfo);
      this.tableData[0] = {
        ordersId: null,
        ordersNum: null,
        invoiceCompName: null,
        invoiceTitle: null,
        goodsName: null,
        counts: null,
        unit: null,
        salesMan: null,
      };
      this.isinitByOrder = true;
      this.insertEvent();
      this.currentRow = this.$refs[this.tableName].getTableData().tableData[0];
      if (this.cate == "Sales") {
        // 开票

        this.currentRow.ordersNum = orderInfo.ordersNum;
        this.currentRow.invoiceTitle = orderInfo.buyerName;
        this.currentRow.goodsName = orderInfo.goodsName;
        this.currentRow.counts = orderInfo.goodsCounts;
        this.currentRow.unit = orderInfo.goodsUnit;
        if (!matchOrder) {
          this.currentRow.ordersId = orderInfo.id;
          this.currentRow.salesMan = orderInfo.saleMan;
          this.currentRow.invoiceCompName = orderInfo.compName;
        }
      } else {
        // 抵扣票
        this.currentRow.ordersId = orderInfo.id;
        this.currentRow.ordersNum = orderInfo.ordersNum;
        this.currentRow.invoiceCompName = orderInfo.sellerName;
        this.currentRow.invoiceTitle = orderInfo.compName;
        this.currentRow.goodsName = orderInfo.goodsName;
        this.currentRow.counts = orderInfo.goodsCounts;
        this.currentRow.unit = orderInfo.goodsUnit;
        this.currentRow.salesMan = orderInfo.saleMan;
      }

      if (!matchOrder) {
        // 不是撮合订单带入
        this.currentRow.salesMan = orderInfo.saleMan;
        this.currentRow.orderRateDeduct = orderInfo.rateDeduct;
        this.currentRow.orderRateDeductManage = orderInfo.rateDeductManage;
        this.currentRow.rateManage = orderInfo.rateManage;
      } else {
        this.currentRow.taxRate = null;
      }
      this.currentRow.laydays = this.timePartRule(orderInfo.beginTime);
      this.currentRow.carShipNum = orderInfo.carShipNum;
      this.currentRow.beginPlace = orderInfo.beginPlace;
      this.currentRow.endPlace = orderInfo.endPlace;

      if (this.currentRow.invoiceCompName && this.currentRow.invoiceTitle) {
        //2.  开票及抵扣票2.0流程，选择订单后自动代入的开票单位及发票抬头要支持修改（重新选择）
        //this.currentRow.canEdit = false;
      }

      // this.chooseOrderEvent(orderInfo)
      this.$refs[this.tableName].reloadData([this.currentRow]);
      this.orderInsert = false;
    },
    timePartRule: function (t) {
      if (t) {
        var timeB = new Date(t);
        var y = 1900 + timeB.getYear();
        var m = "0" + (timeB.getMonth() + 1);
        var d = "0" + timeB.getDate();

        return (
            y + "-" + m.substring(m.length - 2, m.length) + "-" + d.substring(d.length - 2, d.length)
        );
      } else {
        return null;
      }
    },
    getDicByParentList() {
      $api.other.getDicByParentModel
          .GET({
            params: {
              page: 1,
              rows: 10,
            },
          })
          .then((res) => {
            this.dicByParentData = res.data;
          });
    },
    showTempModal() {
      // if (isEmpty(this.formData.compName)) {
      //   this.$XModal.message({status: "error", message: "请先选择所属公司"});
      //   return
      // }
      if (this.cate === "Sales") {
        this.$refs.modalTemplate.setExport("0706销项发票导入模板.xls");
      } else {
        this.$refs.modalTemplate.setExport("0706进项发票导入模板.xls");
      }
      this.templateVisible = true;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    goImport() {
      this.impotEvent();
      // this.isShowCreateInvoice = true;
      // this.isCurImport = true;
      this.templateVisible = false;
    },
    async impotEvent() {
      this.$refs[this.tableName]
          .readFile({
            types: ["xls", "xlsx"],
          })
          .then((evnt) => {
            showLoading();
            const tableData = [];
            const importIds = [];
            const files = evnt.target.files;
            const fileReader = new FileReader();
            fileReader.onload = async (ev) => {
              const data = ev.target.result;
              const workbook = XLSX.read(data, {
                type: "binary",
              });
              const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
              // 解析数据
              if (csvData.split("\n").length > 302) {
                hideLoading();
                this.$XModal.alert({
                  message: "本次导入数据超过300条",
                  status: "error",
                });
                return
              }
              csvData.split("\n").forEach((vRow, index) => {
                if (vRow && index > 0) {
                  const vCols = vRow.split(",");
                  if (isNotEmpty(vCols[1])) {
                    importIds.push(vCols[1]);
                  }
                  let item = {};
                  let vColNum;
                  if (isNotEmpty(vCols[1])) {
                    vColNum = vCols[1].trim();
                  } else {
                    vColNum = null;
                  }
                  if (this.cate === "Sales") {
                    // 销项
                    item = {
                      index: index + 1, //需要
                      ordersNum: vCols[1], //承运人订单号
                      invoiceNum: vCols[2] ? vCols[2].trim() : null, //发票编号
                      addTime: vCols[3] ? getExcelTime(vCols[3].trim()) : null, //开票日期
                      invoiceType: vCols[4] ? (vCols[4].trim() == "增值税普通发票" ? 1 : 2) : null, //发票类型
                      invoiceCompName: this.formData.compName, //开票单位
                      invoiceTitle: vCols[5] ? vCols[5].trim() : null, //发票抬头
                      goodsName: vCols[6] ? vCols[6].trim() : null, //应税商品名称
                      unit: vCols[7] ? vCols[7].trim() : null, //单位
                      counts: vCols[8] ? vCols[8].trim() : null, //应税商品数量
                      price: vCols[9] ? vCols[9].trim() : null, //不含税单价（元）
                      totalAmount: vCols[10] ? vCols[10].trim() : null, //不含税金额
                      taxRate: !isEmpty(vCols[11]) ? vCols[11].replace('%','') : null, //税率（%）
                      taxAmount: vCols[12] ? vCols[12].trim() : null, //税额（元）
                      taxTotalAmount: vCols[13] ? vCols[13].trim() : null, //价税合计（元）
                      salesMan: vCols[14] ? vCols[14].trim() : null, //业务员
                      rateManage: !isEmpty(vCols[15]) ? vCols[15].replace('%','') : null, //费率
                      manageAmount: vCols[16] ? vCols[16].trim() : null, //管理费
                      carShipNum: vCols[17] ? vCols[17].trim() : null, //车船名
                      beginPlace: vCols[18] ? vCols[18].trim() : null, //起运地
                      endPlace: vCols[19] ? vCols[19].trim() : null, //到达地
                      laydays: vCols[20] ? getExcelTime(vCols[20].trim()) : null, //受载/交接日期
                      note: vCols[21] ? vCols[21].trim() : null, //备注
                      logisticsComp: vCols[22] ? vCols[22].trim() : null,
                      logisticsNum: vCols[23] ? vCols[23].trim() : null,
                      fileUuidList: [],
                      fileList: [],
                    };
                  } else {
                    // 进项
                    item = {
                      index: index + 1, //需要
                      ordersNum: vCols[1], //承运人订单号
                      invoiceNum: vCols[2] ? vCols[2].trim() : null, //发票编号
                      addTime: vCols[3] ? getExcelTime(vCols[3].trim()) : null, //开票日期
                      deductTime: vCols[4] ? getExcelTime(vCols[4].trim()) : null, //抵票日期
                      invoiceType: vCols[5] ? (vCols[5].trim() == "增值税普通发票" ? 1 : 2) : null, //发票类型
                      invoiceCompName: vCols[6] ? vCols[6].trim() : null, //开票单位
                      invoiceTitle: this.formData.compName, //发票抬头
                      goodsName: vCols[7] ? vCols[7].trim() : null, //应税商品名称
                      unit: vCols[8] ? vCols[8].trim() : null, //单位
                      counts: vCols[9] ? vCols[9].trim() : null, //应税商品数量
                      price: vCols[10] ? vCols[10].trim() : null, //不含税单价（元）
                      totalAmount: vCols[11] ? vCols[11].trim() : null, //不含税金额
                      taxRate: !isEmpty(vCols[12]) ? vCols[12].replace('%','') : null, //税率（%）
                      taxAmount: vCols[13] ? vCols[13].trim() : null, //税额（元）
                      taxTotalAmount: vCols[14] ? vCols[14].trim() : null, //价税合计（元）
                      salesMan: vCols[15] ? vCols[15].trim() : null, //业务员
                      deductType: vCols[16] ? vCols[16].trim() : null, //抵扣方式
                      rateDeduct: !isEmpty(vCols[17]) ? vCols[17].replace('%','') : null, //抵扣比例
                      manageAmount: !isEmpty(vCols[18]) ? parseFloat(vCols[18].trim()) : null, //抵扣管理费
                      carShipNum: vCols[19] ? vCols[19].trim() : null, //车船名
                      beginPlace: vCols[20] ? vCols[20].trim() : null, //起运地
                      endPlace: vCols[21] ? vCols[21].trim() : null, //到达地
                      laydays: vCols[22] ? getExcelTime(vCols[22].trim()) : null, //受载/交接日期
                      note: vCols[23] ? vCols[23].trim() : null, //备注
                      replaceTaxpayer: vCols[24] ? vCols[24].trim() : null, //纳税人名称
                      repalceTaxNum: vCols[25] ? vCols[25].trim() : null, //纳税人号码
                      fileUuidList: [],
                      fileList: [],
                    };
                    if (vCols[16] && vCols[16].trim() == "价税合计") {
                      item.deductType = 1;
                    } else if (vCols[16] && vCols[16].trim() == "增值税") {
                      item.deductType = 2;
                    } else {
                      item.deductType = null;
                    }
                  }

                  if (this.cate == "Sales") {
                    if (
                        !isEmpty(item.taxTotalAmount) &&
                        !isEmpty(item.rateManage) &&
                        isEmpty(item.manageAmount)
                    ) {
                      this.calcMoneyTreAll(item);
                    }
                  } else {
                    if (
                        !isEmpty(item.taxTotalAmount) &&
                        !isEmpty(item.rateDeduct) &&
                        isEmpty(item.manageAmount)
                    ) {
                      this.calcMoneyTreAll(item);
                    }
                  }

                  tableData.push(item);
                }
              });
              let res;
              if (this.cate == "Sales") {
                res = await $api.ordersBuyer.post("queryOrdersBuyerSalesInfoList", importIds);
              } else {
                res = await $api.ordersSeller.post("queryOrdersSellerSalesInfoList", importIds);
              }
              if (res.status == 1) {
                let orders = res.data;
                tableData.map((i) => {
                  if (i.ordersNum) {
                    let orderInfo = orders.find((j) => j.ordersNum === i.ordersNum);
                    if (isNotEmpty(orderInfo)) {
                      if (this.cate == "Sales") {
                        // i.ordersBuyerId = orderInfo.ordersId;
                        // && i.invoiceCompName == orderInfo.compName
                        if (isEmpty(i.rateManage)) {
                          i.rateManage = orderInfo.rateManage;
                        }
                        if (isEmpty(i.manageAmount)) {
                          this.calcMoneyTreAll(i);
                        }
                      } else {
                        // i.ordersSellerId = orderInfo.ordersId
                        if (isEmpty(i.rateDeduct)) {
                          i.rateDeduct =
                              i.deductType == 1 ? orderInfo.rateDeduct : orderInfo.rateDeductManage;
                        }
                        if (isEmpty(i.manageAmount)) {
                          this.calcMoneyTreAll(i);
                        }
                      }
                      i.compName = orderInfo.compName ? orderInfo.compName : "";
                      // i.salesMan = orderInfo.salesMan ? orderInfo.salesMan : ''
                      // i.salesManId = orderInfo.salesManId ? orderInfo.salesManId : ''
                      // i.isOrderSalesMan = true
                    }
                  }
                });
                this.$set(this, 'tableData', tableData);
                // this.tableData = tableData;
                this.updateFooterEvent();
              } else {
                this.$XModal.alert({
                  message: res.message ? res.message : "接口异常",
                  status: "error",
                });
              }
              setTimeout(() => {
                hideLoading();
              }, 1000);
            };
            fileReader.readAsBinaryString(files[0]);
          });
    },
    async requireValidTwo(e) {
      if (this.cate === 'Income') {
        return await requireValidTaxpayer(e)
      }
    },

    async requireValid(e) {
      // if (e.columnIndex == 2) {
      //   if (this.isImport && isEmpty(e.row.ordersNum)) {
      //     return Promise.reject(new Error('导入必须填写订单号'))
      //   }
      // } else if (empties.includes(e.cellValue)) {
      //   return Promise.reject(new Error(e.column.title + '必填'))
      // }
      // console.log(e.column.title, 'e.row');
      if (e.column.title == "发票号码" && isNotEmpty(e.row.invoiceNum)) {
        let rep8 = /^(\d{8})?$/;
        let rep20 = /^(\d{20})?$/;
        let invoiceNum = e.row.invoiceNum.trim();
        if (!rep8.test(invoiceNum) && !rep20.test(invoiceNum)) {
          return Promise.reject(new Error("请输入正确的发票号码"));
        }
      }

      // if (e.column.title == "发票抬头" && isNotEmpty(e.row.invoiceTitle) && e.row.invoiceTitle === this.formData.compName) {
      //   return Promise.reject(new Error("所属公司与发票抬头不能一致"));
      // }
      //
      // if (e.column.title == "开票单位" && isNotEmpty(e.row.invoiceCompName) && e.row.invoiceCompName === this.formData.compName) {
      //   return Promise.reject(new Error("所属公司与开票单位不能一致"));
      // }

      if (this.cate === "Income" && e.column.title == "抵扣日期" && isEmpty(e.row.deductTime)) {
        return Promise.reject(new Error("抵扣日期不能为空"));
      }
      // if (this.cate === 'Sales' && e.column.title == '管理费' && isEmpty(e.row.manageAmount)) {
      //   return Promise.reject(new Error('管理费不能为空'))
      // }
      // if (empties.includes(e.cellValue) && e.column.title !== '抵扣管理费') {
      //   return Promise.reject(new Error(e.column.title + '必填'))
      // }
      if (empties.includes(e.cellValue)) {
        return Promise.reject(new Error(e.column.title + "必填"));
      }
    },
    cellClickEvent(e) {
      let col = e.column.property;
      switch (col) {
        case "ordersNum":
          if (this.canInsert) {
            if (this.isinitByOrder) {
              return;
            }
            this.currentRow = e.row;
            this.isShowChooseOrder = true;
            this.$nextTick(() => {
              this.$refs.chooseOrder.init(this.cate);
            });
          }
          break;
      }
      this.$refs[this.tableName].clearValidate();
    },
    changeInvoiceType(row) {
      console.log("changeInvoiceType", row);
    },
    changeDeductType(index) {
      // 1: 价税合计， 2：增值税
      this.currentRow = this.$refs[this.tableName].getTableData().tableData[index];
      if (this.currentRow.salesManId) {
        this.querySalesDetail(index);
      }
      this.$set(this.currentRow, 'rateDeduct', this.currentRow.deductType === 1
          ? (this.currentRow.orderRateDeduct ? this.currentRow.orderRateDeduct : null)
          : this.currentRow.orderRateDeductManage);
      this.calcMoneyTreAll(this.currentRow, "rateDeduct");
    },
    async chooseOrderEvent(order, type) {
      // 会带入，开票单位、发票抬头、应税商品名称、数量、单位
      console.log("chooseOrderEvent", order);
      if (this.cate == "Sales") {
        // 开票
        this.matchOrder = order.isMatchOrder;
        this.currentRow.isMatchOrder = order.isMatchOrder;
        this.currentRow.ordersVersion = order.ordersVersion;
        this.currentRow.ordersId = order.id;
        this.currentRow.ordersNum = order.ordersNum;
        this.currentRow.invoiceTitle = order.buyerName;
      } else {
        // 抵扣票
        if (type === 'sub') {
          this.currentRow.isSub = true;
          this.currentRow.ordersId = order.id;
          this.currentRow.ordersNum = order.ordersNumAttached;
          this.currentRow.salesMan = order.saleMan;
          this.currentRow.salesManId = order.saleManId;
          this.currentRow.ordersVersion = 4;
          this.currentRow.taxTotalAmount = order.payAmount;
        } else {
          this.currentRow.isSub = false;
          this.currentRow.ordersId = order.id;
          this.currentRow.ordersNum = order.ordersNum;
        }
        if (order.sellerUserType === 2) {
          this.currentRow.invoiceCompName = order.sellerName;
        }
      }
      if (!type) {
        this.currentRow.goodsName = order.goodsName;
        this.currentRow.counts = order.counts;
        this.currentRow.unit = order.goodsUnit;

        // 选择撮合订单 有些字段为空
        if (order.isMatchOrder) {
          this.currentRow.taxRate = null;
          this.currentRow.ordersVersion = 3
        } else {
          this.currentRow.ordersVersion = 2
          this.currentRow.orderRateDeduct = order.rateDeduct;
          this.currentRow.orderRateDeductManage = order.rateDeductManage;
          this.currentRow.rateManage = order.rateManage;
          this.currentRow.salesMan = order.saleMan;
        }
        this.currentRow.laydays = this.timePartRule(order.beginTime);
        this.currentRow.carShipNum = order.carShipNum;
        this.currentRow.beginPlace = order.beginPlace;
        this.currentRow.endPlace = order.endPlace;
      }

      this.$refs[this.tableName].updateStatus();
      // this.currentRow.rateManage = order.rateManage

      this.isShowChooseOrder = false;
      if (this.currentRow.invoiceCompName && this.currentRow.invoiceTitle) {
        //2.  开票及抵扣票2.0流程，选择订单后自动代入的开票单位及发票抬头要支持修改（重新选择）
        // this.currentRow.canEdit = false;
      }

      this.$refs[this.tableName].clearValidate("ordersNum");
      this.updateFooterEvent();
    },
    openChooseAccount(row, field) {
      this.isShowChooseAccount = true;
      this.currentRow = row;
      this.currentChooseColumn = field;
      this.$nextTick(() => {
        this.$refs.chooseAccount.init();
      })
    },
    openChoosePerson(row, field) {
      this.isShowInvoiceAccount = true;
      this.currentRow = row;
      this.currentChooseColumn = field;
      this.$refs.chooseInvoiceAccount.initAccount(1, 1);
    },
    chooseAccountEvent(account, type) {
      //选择开票单位 使用用户名
      // this.currentRow[this.currentChooseColumn] = type === 1 ? account.compName : account.realName;
      this.currentRow[this.currentChooseColumn] = account.userName;
      this.isShowChooseAccount = false;
      this.$refs[this.tableName].clearValidate(this.currentChooseColumn);
    },
    chooseInvoiceAccountEvent(account, type) {
      this.currentRow[this.currentChooseColumn] = account.userName;
      this.currentRow['repalceTaxNum'] = account.idcardNum;
      this.currentRow['taxpayerId'] = account.id;
      this.currentRow['disabledEditIdCarNum'] = isNotEmpty(account.idcardNum);
      this.$refs.xTable.clearValidate("repalceTaxNum");
      this.isShowInvoiceAccount = false;
      this.$refs.xTable.clearValidate(this.currentChooseColumn);
    },
    showChooseCarShip(row) {
      this.currentRow = row;
      this.isShowChooseCarShip = true;
      this.$refs.chooseCarShip.init();
    },
    chooseCarShip(data, cate) {
      this.currentRow.carShipNum = cate == "car" ? data.carNum : data.shipName;
      this.isShowChooseCarShip = false;
    },
    insertEvent() {
      let tableData = this.$refs[this.tableName].getTableData().tableData;
      this.$refs[this.tableName].clearValidate();
      let record = assign(this.dataTmp);
      if (this.formData.compName) {
        if (this.cate === 'Sales') {
          record.invoiceCompName = this.formData.compName;
        } else {
          record.invoiceTitle = this.formData.compName;
        }
      }
      if (!this.orderInsert) {
        record = Object.assign(record, {
          ordersNum: tableData[0].ordersNum, //承运人订单号
          invoiceCompName: this.matchOrder ? null : tableData[0].invoiceCompName, //开票单位
          invoiceTitle: tableData[0].invoiceTitle, //发票抬头
          goodsName: tableData[0].goodsName, //应税商品名称
          counts: tableData[0].counts, //应税商品数量
          unit: tableData[0].unit, //单位
          salesMan: tableData[0].salesMan,
          // taxRate: tableData[0].taxRate,
          carShipNum: tableData[0].carShipNum,
          beginPlace: tableData[0].beginPlace,
          rateManage: tableData[0].rateManage,
          endPlace: tableData[0].endPlace,
          laydays: tableData[0].laydays,
          orderRateDeduct: tableData[0].orderRateDeduct,
          orderRateDeductManage: tableData[0].orderRateDeductManage,
        });
      }
      record.index = tableData.length + 1;
      record.fileList = [];
      record.fileUuidList = [];
      this.$refs[this.tableName].insertAt(record, -1);
    },
    async removeEvent() {
      let checkboxRecords = this.$refs[this.tableName].getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      if (!this.canInsert) {
        //不能全部删除
        if (checkboxRecords.length == this.$refs[this.tableName].getTableData().tableData.length) {
          this.$XModal.message({
            message: "不能全部删除,至少保留一条",
          });
          return;
        }
      }
      let confirmRes = await this.$XModal.confirm("删除后不可恢复", "是否删除？");
      if (confirmRes == "confirm") {
        this.$refs[this.tableName].removeCheckboxRow();
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs[this.tableName].getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }

      this.$refs[this.tableName].insertAt(checkboxRecords, -1);
    },
    async validEvent() {
      const errMap = await this.$refs[this.tableName].validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async submitEvent(type = "new") {
      this.isSubmit = true;
      if (type === "new") {
        if (isEmpty(this.formData.compName)) {
          this.$XModal.message({status: "error", message: "请先选择所属公司"});
          return
        }

        if (isEmpty(this.formData.isQqPush)) {
          this.$XModal.message({status: "error", message: "请选择同步企企"});
          return
        }
        let sts = await this.validEvent();
        if (!sts) {
          this.$XModal.message({
            status: "error",
            message: "校验不通过！",
          });
          return;
        }
      }

      let table = this.$refs[this.tableName].getTableData();

      if (table.tableData.length == 0) {
        this.$XModal.message({
          message: "请先添加发票",
        });
        return;
      }
      let obj = {};
      let rows = [];
      let checkTotal = false;
      let message2 = "";
      let checkInvoice = false;
      table.fullData.some((item, index) => {
        let row = assign(item);
        if (row.laydays != null && row.laydays != "") {
          row.laydays = this.$utils.timestamp(this.$utils.toStringDate(row.laydays));
        }
        if (row.addTime != null && row.addTime != "") {
          row.addTime = this.$utils.timestamp(this.$utils.toStringDate(row.addTime));
        }
        if (row.deductTime != null && row.deductTime != "") {
          row.deductTime = this.$utils.timestamp(this.$utils.toStringDate(row.deductTime));
        }
        if (row.taxTotalAmount != null && row.taxTotalAmount != "") {
          row.amount = row.taxTotalAmount;
        }
        // if (row.isMatchOrder) {
        //   row.ordersVersion = 3;
        // } else {
        //   row.ordersVersion = 2;
        // }
        row.compName = this.cate == "Sales" ? row.invoiceCompName : row.invoiceTitle;
        row.invoiceNum = row.invoiceNum ? row.invoiceNum.trim() : null;
        rows.push(row);
        if (row.totalAmount && row.taxAmount && row.taxTotalAmount) {
          let totalAmount = Math.round((parseFloat(row.totalAmount) + parseFloat(row.taxAmount)) * 100) / 100;
          if (totalAmount !== parseFloat(row.taxTotalAmount)) {
            this.$XModal.alert({
              message: `序号${index + 1},不含税金额+税额≠价税合计`,
              status: "error",
            });
            checkTotal = true;
            return true
          }
        }
        if (this.cate === "Sales") {
          if (row.invoiceTitle === this.formData.compName) {
            message2 = message2 + `序号${index + 1}，所属公司与发票抬头不能一致\n`;
            checkInvoice = true;
          }
        } else {
          if (row.invoiceCompName === this.formData.compName) {
            message2 = message2 + `序号${index + 1}，所属公司与开票单位不能一致\n`;
            checkInvoice = true;
          }
        }
      });
      let uploadtable = this.uploadData;
      obj.attachFile = uploadtable[0].fileUuidList;
      obj.applyTime = this.$utils.timestamp(this.$utils.toStringDate(this.formData.applyTime));
      obj.instanceName = this.formData.instanceName;
      obj.instanceNum = this.formData.instanceNum;
      obj.applyUserId = this.formData.applyUserId;
      obj.leaderId = this.formData.leaderId;
      obj.managerId = this.formData.managerId;
      obj.reterenceId = this.formData.reterenceId;
      obj.reterenceName = this.formData.reterence;
      obj.flowTempletId = this.flowTempletId;
      obj.isQqPush = this.formData.isQqPush;

      obj.invoiceList = rows;
      if (this.isInitBySave) {
        obj.id = this.initBySaveId;
      }
      this.commitObj = obj;

      if (checkTotal) return;
      if (checkInvoice) {
        this.$refs.messageModal2.setMessage(message2);
        this.messageVisible2 = true;
        return
      }
      let action = "";
      if (type === "new") {
        action =
            this.cate == "Sales" ? "saveFlowForInvoiceSellerTwo" : "saveFlowForInvoiceBuyerTwo";
      } else {
        action =
            this.cate == "Sales"
                ? "saveDraftFlowForInvoiceSellerTwo"
                : "saveDraftFlowForInvoiceBuyerTwo";
      }
      let msgTxt = type === "new" ? "提交成功" : "保存成功";
      // let action = this.cate == 'Sales' ? 'saveFlowForInvoiceSellerTwo' : 'saveFlowForInvoiceBuyerTwo'

      showLoading();
      let res = await $api.flowInstance.request(action, obj);
      hideLoading();

      if (res.status == 1) {
        this.$XModal.message({
          status: "success",
          message: msgTxt,
        });
        this.tableData = [];
        // debugger
        this.$emit("close");
        window.close();
      } else if (res.status == 0) {
        if (isNotEmpty(res.data)) {
          res.data.forEach(item => {
            if (item.failMsg.indexOf("身份证号码不一致") > -1) {
              this.tableData[item.failArrayIndex].repalceTaxNum = ''
            }
          });
          showFailMsgList(res.data);
        } else {
          this.$XModal.message(res.message);
        }
      } else if (res.status === -1) {
        let data = res.data;
        let message = "";
        if (data.length > 0) {
          data.map(i => {
            message = message + "序号" + (table.fullData[i.failArrayIndex].index) + "，" + i.failMsg + "\n";
          });
        }
        this.$refs.messageModal.setMessage(message);
        this.messageVisible = true;
      } else {
        if (!res.message) {
          res.message = "接口异常";
        }
        this.$XModal.message(res.message);
      }
      this.$emit("init");
    },
    async goOn() {
      let action = this.cate === "Sales" ? "saveFlowForInvoiceSellerTwo" : "saveFlowForInvoiceBuyerTwo";
      let msgTxt = "提交成功";
      let table = this.$refs[this.tableName].getTableData();
      showLoading();
      let res = await $api.flowInstance.request(action, this.commitObj);
      hideLoading();

      if (res.status == 1) {
        this.$XModal.message({
          status: "success",
          message: msgTxt,
        });
        this.tableData = [];
        // debugger
        this.$emit("close");
        window.close();
      } else if (res.status == 0) {
        if (isNotEmpty(res.data)) {
          res.data.forEach(item => {
            if (item.failMsg.indexOf("身份证号码不一致") > -1) {
              this.tableData[item.failArrayIndex].repalceTaxNum = ''
            }
          });
          showFailMsgList(res.data);
        } else {
          this.$XModal.message(res.message);
        }
      } else if (res.status === -1) {
        let data = res.data;
        let message = "";
        if (data.length > 0) {
          data.map(i => {
            message = message + "序号" + (table.fullData[i.failArrayIndex].index) + "，" + i.failMsg + "\n";
          });
        }
        this.$refs.messageModal.setMessage(message);
        this.messageVisible = true;
      } else {
        if (!res.message) {
          res.message = "接口异常";
        }
        this.$XModal.message(res.message);
      }
      this.$emit("init");
    },
    async cover() {
      let obj = this.commitObj;
      obj.invoiceList.map(i => {
        i.isForce = 1;
      })
      showLoading();
      let res = await $api.flowInstance.request('saveFlowForInvoiceSellerTwo', obj);
      hideLoading();
      if (res.status === 1) {
        this.$XModal.message({
          status: "success",
          message: '提交成功',
        });
        this.messageVisible = false;
        // debugger
        this.$emit("close");
        window.close();
      } else {
        if (!res.message) {
          res.message = "接口异常";
        }
        this.$XModal.message(res.message);
      }
    },
    footerCellClassName({$rowIndex, column, columnIndex}) {
      return "footer-cell";
    },
    footerMethod({columns, data}) {
      return invoiceFooter({
        columns,
        data,
        countRtnVo: null,
      });
    },
    updateFooterEvent() {
      this.$refs[this.tableName].updateFooter();
    },
    calcMoney(row, field) {
      // row.counts = isNaN(row.counts) ? '' : row.counts
      // row.price = isNaN(row.price) ? '' : row.price
      if (row.counts !== "" && row.price !== "") {
        let priceAmount = Math.round(row.counts * row.price * 100) / 100;
        row.totalAmount = isNaN(parseInt(priceAmount)) ? "" : priceAmount;
        this.calcMoneyAll(row);
      } else {
        row.totalAmount = "";
      }
      this.updateFooterEvent();
    },
    calcMoneyAll(row) {
      // row.taxRate = isNaN(parseInt(row.taxRate)) ? '' : row.taxRate;
      // row.totalAmount = isNaN(parseInt(row.totalAmount)) ? '' : row.totalAmount;
      if (row.taxRate !== "" && row.totalAmount !== "") {
        row.taxAmount = Math.round(row.totalAmount * row.taxRate) / 100;
        this.calcMoneySecAll(row);
      } else {
        row.taxAmount = "";
      }
      this.updateFooterEvent();
    },
    calcMoneySecAll(row) {
      // row.taxAmount = isNaN(parseInt(row.taxAmount)) ? '' : row.taxAmount;
      // row.totalAmount = isNaN(parseInt(row.totalAmount)) ? '' : row.totalAmount;
      if (row.taxAmount !== "" && row.totalAmount !== "") {
        if (row.taxAmount !== null && row.totalAmount !== null) {
          row.taxTotalAmount =
              Math.round((parseFloat(row.taxAmount) + parseFloat(row.totalAmount)) * 100) / 100;
        }
        this.calcMoneyTreAll(row);
      } else {
        row.taxTotalAmount = "";
      }
      this.updateFooterEvent();
    },
    calcMoneyTreAll(row) {
      let rate = "";
      if (this.cate === "Income") {
        rate = row.rateDeduct;
      } else {
        rate = row.rateManage;
        row.deductType = 1;
      }
      rate = isNaN(parseInt(rate)) ? "" : rate;

      if (!row.deductType) {
        return;
      }
      if (row.deductType === 1) {
        if (rate !== "" && row.taxTotalAmount !== "") {
          row.manageAmount = Math.round(row.taxTotalAmount * rate) / 100;
        } else {
          row.manageAmount = "";
        }
      } else {
        if (rate !== "") {
          row.manageAmount = Math.round(row.taxAmount * rate) / 100;
        } else {
          row.manageAmount = "";
        }
      }
      this.updateFooterEvent();
    },
    authCreate() {
      return (
          (this.cate == "Sales" && this.isHavePermission("invoice:createInvoiceSeller")) ||
          (this.cate == "Income" && this.isHavePermission("invoice:createInvoiceBuyer"))
      );
    },
  },
};
</script>
<style>
.my-dropdown4 {
  width: 600px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
}

.link-text {
  color: #2d8cf0;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

.footer-cell {
  border: none;
  background: #e5f2ff;
  background-size: 0 100%, 100% 1px !important;
}

.window {
  padding: 20px;
  background: #ffffff;
  height: 100vh;
}

.pay-modal-main {
  padding-top: 20px;
}
</style>
<style scoped>
.add-box .produre .vxe-input, .add-box .produre .vxe-select, .add-box .produre .ivu-cascader .ivu-input {
  height: 30px;
}

.produre .vxe-select >>> .vxe-input {
  height: 30px;
}

.produre >>> .vxe-body--column {
  height: 30px !important;
}

.produre >>> .vxe-body--column:not(.col--ellipsis), .produre >>> .vxe-footer--column:not(.col--ellipsis), .produre >>> .vxe-header--column:not(.col--ellipsis) {
  padding: 3px 0;
}

.footer-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
  background-color: #fff;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 15px;
  display: flex;
  justify-content: flex-end;
}

.left10 {
  margin-left: 10px;
}
</style>
